import { isString } from '../utils/base'
import { HOST_STATIC } from '../const'

var userPrototype = {
  isValid() {
    if (this.uid > 0 && this.isValidMobile > 0) {
      return true
    }
    return false
  },
  isTempUser() {
    return this.uid > 0 && !(this.isValidMobile > 0)
  }
}

export function KUser(rawData) {
  const R = Object.assign(
    Object.create(userPrototype),
    {
      uid: 0,
      nick: '未登录',
      oid: '',
      status: 0,
      gender: 0,
      logoAlbumId: 0,
      qrPid: 0,
      vip: 0,
      mobile: '',
      mobCountry: '',
      email: '',
      plat: 0,
      address: '',
      tel: '',
      username: '',
      logoLg: '', // 大图:250
      logoMd: '', // 中图:120
      logoSm: '', // 小图:50
      logoSrc: '', // 原图
      avatar: ''
    },
    rawData
  )

  const { uid, nick, isRealName, isValidMobile } = R
  // 基本
  R.uid = uid > 0 ? +uid : 0
  R.nick = isString(nick) ? nick : `wz_${R.uid}`
  R.isRealName = isRealName > 0 ? +isRealName : 0
  R.isValidMobile = isValidMobile > 0 ? +isValidMobile : 0

  // 头像
  const logo = R.logo || {}
  let { thumb120, thumb50, thumb, src } = logo
  src = src || ''
  thumb = thumb || src
  thumb50 = thumb50 || thumb
  thumb120 = thumb120 || thumb50
  R.thumb = thumb
  R.thumb50 = thumb50
  R.thumb120 = thumb120
  R.logoSrc = R.thumb120 = thumb120
  R.logoPid = logo.pid > 0 ? logo.pid : 0
  R.logoSm = R.thumb50 // 50
  R.logoMd = R.thumb120 // 120
  R.logoLg = R.thumb // 250

  // 会员等级
  const { stageLevel } = R
  if (stageLevel) {
    let { stage, level } = stageLevel
    stage = stage > 0 ? +stage : 0
    level = level > 0 ? +level : 0
    R.stage = stage
    R.level = level
  } else {
    R.stage = 0
    R.level = 0
  }

  return R
}

// 格式化用户信息：账号信息
export function KAccount(account) {
  const defaultLogo =
    '//' + HOST_STATIC + '/award/kline/img/2.2/avatar_not_logged_in.png'
  account = KUser(account)
  // TODO: 登录账号专用属性
  if (!account.uid) {
    account.thumb = account.thumb50 = account.thumb120 = account.logoSrc = defaultLogo
  }
  return account
}
